import { ChildMachineConfig } from "@checkout/types";
import { ActionTypes } from "./actions";
import { GuardTypes } from "./guards";
import { ChangeForAnyReasonState } from "./types";

export const getChfarMachine = (config: ChildMachineConfig) => ({
  initial: ChangeForAnyReasonState.route,
  states: {
    [ChangeForAnyReasonState.route]: {
      always: [
        {
          target: ChangeForAnyReasonState.addProduct,
          cond: GuardTypes.hasChfarIdAndEnabled,
        },
        {
          target: config.nextState,
        },
      ],
    },
    [ChangeForAnyReasonState.addProduct]: {
      always: [
        {
          actions: ActionTypes.addChfarProduct,
          target: config.nextState,
        },
      ],
    },
  },
});
